import Service from './Service';

class PayService {
  constructor(props) {
    this.PATH = {
      DETAIL: 'c/deal/getDealDetail',
      PAY_SIGN: 'c/deal/makePayFlow',
      APPID: 'anon/cashier/getBkAppid',
      WEB_PAY_DETAIL: 'c/deal/onlinePayRequest',
      QRCODE_PAY_DETAIL: 'anon/institution/getInstContractQrcode',
      STUDENT_DETAIL: 'anon/student/listStudentByPhoneAndInstId',
      GRADE_LIST: 'anon/institution/getInstGrade',
      FOLLOWER_LIST: 'anon/institution/getInstSubAccount',
      QRCODE_PAY_PREPAY: 'c/deal/byQrcode',
      INST_SIMPLE: 'anon/institution/simple',
      SCAN_PAY_SIGN: 'anon/cashier/makeCashierJsPay',
      SCAN_PAY_DETAIL: 'anon/cashier/getStaticCodeDeal',
      DETAIL_BY_CONTRACT_ID: 'c/deal/getContractVO',
      CHECK_STUDENT_QRCODE: 'c/deal/check/student/qrcode',
      XM_SCAN_PAY_SIGN: 'b/advertise/pay',
      XM_PAY_SIGN1: 'b/pay/sybWxWapV1',
      XM_PAY_SIGN: 'b/pay/sybWxWap',
      XMSPALPAY: 'b/pay/sybAliWap',
      XMAPPID: 'b/advertise/pay/appid',
      SAVEACCOUNT: 'b/advertise/account/save',
      XMAlIPAY: 'b/pay/aliwap',
      XMSPALPAY1: 'b/pay/sybAliWapV1',
      CHECK_MONTH_COURSE: 'c/deal/monthCourseConflictCheck',
      OPEN_XM_PAY: 'c/institution/mybank/registerstatus',
      NEWYEARORDER: 'b/newyear/placeAnOrder',
      SASSORDER: 'b/pay/getSaasOrderWeb',
      PAYSUCCESS: 'b/pay/pendingStatus',
      PAYUNMARK: 'b/pay/unMark',
      TLSTATUSBYINSTID: 'finance/anon/c/lbf/tl/status/instId',
      TLSTATUSBYDEALID: 'finance/anon/c/lbf/tl/status/dealId',
      ALL_PAY_STATUS: 'finance/anon/xmpay/getInstPayStatus',
      PAY_INFO: 'anon/aiTutoring/getTutoringAdmin',
      PAY_PREAI_QUOTA: 'anon/aiTutoring/preAiQuota',
      PAY_QUOTA_DETAIL: 'anon/aiTutoring/getQuotaDetail',
      CUSTOMITEM: 'anon/customItem/get',
    };
  }

  checkMonthCourse(params) {
    return Service.doAsyncRequest(this.PATH.CHECK_MONTH_COURSE, {
      params,
      queryUserInfo: false,
    });
  }

  // 获取机构信息
  getInstSimple(instId) {
    const params = {
      instId,
    };
    return axios.Customer(this.PATH.INST_SIMPLE, params);
  }
  // 获取机构信息
  getInstCustom(instId) {
    const params = {
      instId,
    };
    return axios.Finance(this.PATH.CUSTOMITEM, params);
  }
  getDealDeatil(dealId) {
    const params = {
      dealId: dealId,
    };
    return Service.doAsyncRequest(this.PATH.DETAIL, {
      params: params,
      queryUserInfo: false,
    });
  }

  getWebPayDealDetail(dealId, returnUrl) {
    const params = {
      dealId: dealId,
      payType: 3,
      openId: 11,
      device: window.platformCheck().system,
      authCode: 11,
      returnUrl: returnUrl,
    };
    return Service.doAsyncRequest(this.PATH.WEB_PAY_DETAIL, {
      params: params,
      queryUserInfo: false,
    });
  }

  makePaySign(dealId, payType, openId, auth_code) {
    const params = {
      dealId: dealId,
      payType: payType,
      openId: openId,
      device: window.platformCheck().system,
      authCode: auth_code,
    };
    return Service.doAsyncRequest(this.PATH.PAY_SIGN, {
      params: params,
      queryUserInfo: false,
    });
  }

  makeScanPaySign(instId, openId, amount, remark, belongName, payType, auth_code, phone, customItem) {
    const params = {
      instId: instId,
      amount: amount,
      remark: remark,
      payType: payType,
      openId: openId,
      belongName,
      device: window.platformCheck().system,
      authCode: auth_code,
      phone,
      customItem, 
    };
    return axios.Customer(this.PATH.SCAN_PAY_SIGN, params);
  }

  makeXMScanPaySign(money, paymentType, note, openId, auth_code) {
    const params = {
      money,
      paymentType,
      note,
      openId,
      authCode: auth_code,
    };
    return Service.doAsyncRequest(this.PATH.XM_SCAN_PAY_SIGN, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  payUnmark(orderId) {
    const params = {
      orderId,
    };
    return Service.doAsyncRequest(this.PATH.PAYUNMARK, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  getSaasOrderWeb(orderId) {
    const params = {
      orderId,
    };
    return Service.doAsyncRequest(this.PATH.SASSORDER, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  getXMAppid(platformType) {
    const params = {
      platformType,
    };
    return Service.doAsyncRequest(this.PATH.XMAPPID, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  newYearOrder(params) {
    return Service.doAsyncRequest(this.PATH.NEWYEARORDER, {
      params: JSON.stringify(params),
      queryUserInfo: false,
      isSass: true,
      isLogin: true,
      contentType: 'application/json; charset=UTF-8',
    });
  }

  makeALiPaySign(amount, note) {
    const params = {
      amount,
      note,
    };
    return Service.doAsyncRequest(this.PATH.XMAlIPAY, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  makeXMPaySign(amount, paymentType, note, openId, auth_code) {
    const params = {
      amount,
      paymentType,
      note,
      openId,
      authCode: auth_code,
    };
    return Service.doAsyncRequest(this.PATH.XM_PAY_SIGN, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  makeSPALiPaySign(amount, auth_code, note) {
    const params = {
      amount,
      authCode: auth_code,
      note,
    };
    return Service.doAsyncRequest(this.PATH.XMSPALPAY, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  makeXMPaySign1(orderId, openId) {
    const params = {
      orderId,
      openId,
    };
    return Service.doAsyncRequest(this.PATH.XM_PAY_SIGN1, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }
  makeSPALiPaySign1(orderId, authCode) {
    const params = {
      orderId,
      authCode,
    };
    return Service.doAsyncRequest(this.PATH.XMSPALPAY1, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  paySuccess(orderId) {
    const params = {
      orderId,
    };
    return Service.doAsyncRequest(this.PATH.PAYSUCCESS, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  saveAccount(username, phoneNumber) {
    const params = {
      username,
      phoneNumber,
    };
    return Service.doAsyncRequest(this.PATH.SAVEACCOUNT, {
      params: params,
      queryUserInfo: false,
      isSass: true,
    });
  }

  getScanPayDetail(dealId) {
    const params = {
      dealId: dealId,
    };
    return axios.Customer(this.PATH.SCAN_PAY_DETAIL, params);
  }

  getAppid(payType) {
    const params = {
      payType: payType,
    };
    console.log('支付前状态22 payType:', params);
    return axios.Customer(this.PATH.APPID, params);
  }

  // 获取二维码详细信息
  getQrcodeDetail(id) {
    return axios.Customer(this.PATH.QRCODE_PAY_DETAIL, {
      id,
    });
  }

  // 获取学生信息
  getStudentDetail(params) {
    // return Service.doAsyncRequest(this.PATH.STUDENT_DETAIL, {
    //   params, queryUserInfo: false
    // })
    return axios.Customer(this.PATH.STUDENT_DETAIL, params);
  }

  // 获取年级列表
  getGradeList(instId) {
    return axios.Customer(this.PATH.GRADE_LIST, {
      instId,
    });
  }

  // 获取跟进人列表
  getFollowerList(instId) {
    return axios.Customer(this.PATH.FOLLOWER_LIST, {
      instId,
    });
  }

  //二维码报名支付
  qrcodePay(params) {
    return Service.doAsyncRequest(this.PATH.QRCODE_PAY_PREPAY, {
      params,
      queryUserInfo: false,
    });
  }

  getDetailByContractId(id) {
    const params = {
      contractId: id,
    };
    return Service.doAsyncRequest(this.PATH.DETAIL_BY_CONTRACT_ID, {
      params,
      queryUserInfo: false,
    });
  }

  //检测学生是否用该二维码下过单
  checkStudentQrcode(params) {
    return Service.doAsyncRequest(this.PATH.CHECK_STUDENT_QRCODE, {
      params,
      queryUserInfo: false,
    });
  }

  openXMPay(params) {
    return Service.doAsyncRequest(this.PATH.OPEN_XM_PAY, { params });
  }

  // 获取通联支付开通状态
  getTLStatusByInstId(instId) {
    const params = {
      instId,
    };
    return axios.post(this.PATH.TLSTATUSBYINSTID, params);
  }

  getTLStatusByDealId(dealId) {
    const params = {
      dealId,
    };
    return axios.post(this.PATH.TLSTATUSBYDEALID, params);
  }

  //获取第三方的开通状态
  getInstPayStatus(instId) {
    const params = {
      instId,
    };
    return axios.post(this.PATH.ALL_PAY_STATUS, params);
  }
  //获取第三方的开通状态
  getPayInfo(params) {
    return axios.Customer(this.PATH.PAY_INFO, params);
  }
  //获取第三方的开通状态
  getPreAiQuota(params) {
    return axios.Customer(this.PATH.PAY_PREAI_QUOTA, params);
  }
  //获取第三方的开通状态
  getQuotaDetail(params) {
    return axios.Customer(this.PATH.PAY_QUOTA_DETAIL, params);
  }
};

export default new PayService();



// WEBPACK FOOTER //
// ./src/service/PayService.js